export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787',
  useMocks: (import.meta.env.VITE_USE_MOCKS ?? 'false') !== 'false',
  timeoutMs: 30000,
};